import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p>This is a placeholder for the Privacy Policy page.</p>
    </div>
  );
};

export default PrivacyPolicy;